import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
const MainView = () => import('@/components/MainView')
const HomeView = () => import('@/components/HomeView') // 首页
const ScalePlan = () => import('@/components/ScalePlan')
const BuyPlan = () => import('@/components/BuyPlan')
const BindCode = () => import('@/components/BindCode')
const PersonalReport = () => import('@/components/PersonalReport')
const ScaleList = () => import('@/components/ScaleList') // 答题
const FinishView = () => import('@/components/finishView') // 完成答题
const LoginView = () => import('@/components/LoginView')

Vue.use(Router)

if (!store.state.isLogin) {
  if (sessionStorage.getItem('isLogin') && sessionStorage.getItem('studentInfo')) {
    store.commit('setLogin', sessionStorage.getItem('isLogin') === 'true')
    store.commit('setStudentInfo', JSON.parse(sessionStorage.getItem('studentInfo')))
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'LoginView',
      component: LoginView,
      beforeEnter: (to, from, next) => {
        store.state.isLogin ? next('/homeView') : next()
      }
    },
    {
      path: '/buyPlan',
      name: 'BuyPlan',
      component: BuyPlan
    },
    {
      path: '/mainView',
      name: 'MainView',
      redirect: '/homeView',
      component: MainView,
      beforeEnter: (to, from, next) => {
        if (store.state.isLogin) {
          if (store.state.isFresh) {
            next()
          } else {
            store.commit('setFresh', true)
            next('/mainView')
          }
        } else {
          next('/')
        }
      },
      children: [
        {
          path: '/homeView',
          name: 'HomeView',
          component: HomeView
        },
        {
          path: '/scalePlan',
          name: 'ScalePlan',
          component: ScalePlan
        },
        {
          path: '/bindCode',
          name: 'BindCode',
          component: BindCode
        },
        {
          path: '/personalReport',
          name: 'PersonalReport',
          component: PersonalReport
        },
        {
          path: '/scaleEvaluate',
          name: 'ScaleList',
          component: ScaleList
        },
        {
          path: '/finishView',
          name: 'FinishView',
          component: FinishView
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  to.name === 'ScaleList' || to.name === 'FinishView' ? store.commit('setNavState', false) : store.commit('setNavState', true)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js